import React, { useEffect } from 'react';
import { isMobileScreen } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
//import { useIdleTimer } from 'react-idle-timer';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { Menu, MenuItem } from '@apply/components';
import { NotificationButton } from './NotificationButton';
import { ProfileButton } from './ProfileButton';

const reactPlugin = new ReactPlugin();
const mobileScreen = isMobileScreen();

export const appInsightsApply = import.meta.env.VITE_APPINSIGHTS_CLIENT_APPLY;
const ai = new ApplicationInsights({
    config: {
        instrumentationKey: appInsightsApply,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
    },
});
ai.loadAppInsights();

export const Header: React.FC<{ printMode?: boolean }> = ({ printMode }) => {
    const { authentication, isAuthenticated } = useAuthentication();

    // const [logoutTimeout, setLogoutTimeout] = useState<NodeJS.Timeout>();
    // const [isIdle, setIsIdle] = useState(false);
    // const idleWarningDuration = 1000 * 60 * 2;
    // const sessionDuration = 1000 * 60 * 20;
    // const idleDuration = sessionDuration - idleWarningDuration;

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    const logoLink = () => {
        if (isAuthenticated) {
            return '/';
        } else {
            return 'https://www.builderfinance.com';
        }
    };

    return (
        <>
            <header>
                <div className='headerWrapper'>
                    <div className='logoWrapper'>
                        <a
                            href={logoLink()}
                            className='logo no-print'
                        >
                            <img
                                src='/assets/img/logo.webp.html'
                                alt='Builder Finance'
                            />
                        </a>
                    </div>
                    <div
                        className='menuWrapper'
                        style={{ visibility: isAuthenticated ? 'visible' : 'hidden' }}
                    >
                        {!mobileScreen && (
                            <Menu>
                                <MenuItem
                                    active={true}
                                    hint='BFI Apply Home Page'
                                    url='/home'
                                >
                                    Home
                                </MenuItem>
                                {/* <MenuItem
                                    url='/businessandpeople'
                                    active={true}
                                >
                                    Business & People
                                </MenuItem> */}
                                <MenuItem url='/experience'>Experience</MenuItem>
                            </Menu>
                        )}
                    </div>
                    <div
                        className={`${printMode ? 'hidden' : 'headerNav'}`}
                        style={{
                            visibility: isAuthenticated ? 'visible' : 'hidden',
                        }}
                    >
                        <div className='headerNav-navItem'>
                            <NotificationButton printMode={printMode} />
                        </div>
                        <div className='headerNav-navItem'>
                            <ProfileButton
                                user={authentication?.user}
                                printMode={printMode}
                            />
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};
